<template>
  <div>
    <!-- Footer -->
    <footer class="bg-dark text-light py-3">
      <div class="container text-center">
        <p>© 2025 Bee's Atelier | All Rights Reserved</p>
      </div>
    </footer>
  </div>
</template>
<script>

import { useToast } from "vue-toast-notification";
const $toast = useToast();
export default {
  name: "Footer",
  props: {
    logo: {
      type: String,
      default: "./img/logo-light.png",
    },
    whatsappLogo: {
      type: String,
      default: "./img/whatsapp-50.png",
    },
  },
  data() {
    return {
      isDisabled: false,
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {},
  beforeMount() {},
};
</script>